import React, { Fragment } from "react";
import { Listbox, Transition } from "@headlessui/react";
import { CheckIcon, ArrowDownIcon } from "@heroicons/react/outline";
import { Controller } from "react-hook-form";
import classNames from "lib/classNames";
import useTranslation from "next-translate/useTranslation";

export default function Select({
  id,
  label,
  name,
  control,
  errors,
  options,
  labelDisplay,
  required = false,
}) {
  const { t } = useTranslation("common");

  return (
    <Controller
      id={id}
      name={name}
      control={control}
      render={({ field: { value, onChange } }) => (
        <>
          <Listbox as="div" value={value} onChange={onChange}>
            {({ open }) => (
              <>
                <Listbox.Label
                  className={
                    labelDisplay === "invisible"
                      ? "sr-only"
                      : "inline-block mb-1 font-important font-medium uppercase text-sm"
                  }
                >
                  {label}
                  {required && (
                    <>
                      {" "}
                      <span className="text-primary">*</span>
                    </>
                  )}
                </Listbox.Label>
                <div className="relative w-full rounded shadow-spread">
                  <Listbox.Button className="group text-left flex items-center w-full py-4 px-6 bg-primary text-white font-semibold rounded outline-none focus:bg-primary-dark hover:bg-primary-dark transition-colors">
                    <span
                      className={classNames(
                        value && value !== "" && "border-secondary",
                        "block truncate flex-1"
                      )}
                    >
                      {(value && value !== "" && options?.[value]) ||
                        t("form.subject.placeholder")}
                    </span>
                    <span className="pointer-events-none p-2 bg-white/20 rounded-full">
                      <ArrowDownIcon className="h-4 w-4 text-white" />
                    </span>
                  </Listbox.Button>
                  <Transition
                    show={open}
                    as={Fragment}
                    leave="transition ease-in duration-100"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                  >
                    <Listbox.Options
                      className="absolute z-10 max-h-60 w-full py-2 overflow-auto bg-secondary-light shadow-spread focus:outline-none"
                      static
                    >
                      {!required && (
                        <Listbox.Option
                          className={({ active }) =>
                            classNames(
                              active
                                ? "font-bold"
                                : "font-normal hover:font-bold after:hover-bold",
                              "relative flex flex-col py-2 px-4 cursor-default select-none transition-all"
                            )
                          }
                          value={null}
                        >
                          Aucun
                        </Listbox.Option>
                      )}
                      {Object.entries(options).map(([key, label]) => (
                        <Listbox.Option
                          key={key}
                          className={({ active }) =>
                            classNames(
                              active
                                ? "font-bold"
                                : "font-normal hover:font-bold after:hover-bold",
                              "relative flex flex-col py-2 px-4 cursor-default select-none transition-all"
                            )
                          }
                          value={key}
                        >
                          {({ selected }) => (
                            <>
                              <span
                                className={classNames(
                                  selected && "pl-6",
                                  "block truncate"
                                )}
                              >
                                {label}
                              </span>
                              {selected ? (
                                <span
                                  className="absolute inset-y-0 left-0 flex items-center pl-4 text-ccmi"
                                  aria-hidden="true"
                                >
                                  <CheckIcon className="h-3 w-3" />
                                </span>
                              ) : null}
                            </>
                          )}
                        </Listbox.Option>
                      ))}
                    </Listbox.Options>
                  </Transition>
                </div>
              </>
            )}
          </Listbox>
          {errors && <p className="text-sm text-red-500">{errors.message}</p>}
        </>
      )}
      rules={{
        required: required ? t("form.required") : false,
      }}
    />
    // <>
    //   <label
    //     htmlFor={id}
    //     className={classNames(
    //       hasError && "text-red-500",
    //       "inline-block mb-1 font-important font-medium uppercase text-sm"
    //     )}
    //   >
    //     {field["#title"]}
    //     {required && <span className="text-primary"> *</span>}
    //   </label>
    //   <Controller
    //     id={id}
    //     name={name}
    //     control={control}
    //     rules={{
    //       required: required && requiredMessage,
    //       disabled,
    //     }}
    //     render={({ field: { value, onChange } }) => (
    //       <>
    //         <Listbox value={value} onChange={onChange}>
    //           {({ open }) => (
    //             <div className="relative w-full rounded shadow-spread">
    //               <Listbox.Button
    //                 className={classNames(
    //                   hasError ? "border-red-500" : "border-gray-800",
    //                   "group text-left flex items-center w-full py-4 px-6 bg-primary text-white font-semibold rounded outline-none focus:bg-primary-dark hover:bg-primary-dark transition-colors"
    //                 )}
    //               >
    //                 <span
    //                   className={classNames(
    //                     value && value !== "" && "border-secondary",
    //                     "block truncate flex-1"
    //                   )}
    //                 >
    //                   {value &&
    //                   value !== "" &&
    //                   options.find((val) => val.value === value)
    //                     ? options.find((val) => val.value === value).key
    //                     : t("form.subject.placeholder")}
    //                 </span>
    //                 <span className="pointer-events-none p-2 bg-white/20 rounded-full">
    //                   <ArrowDownIcon className="h-4 w-4 text-white" />
    //                 </span>
    //               </Listbox.Button>
    //               <Transition
    //                 show={open}
    //                 as={Fragment}
    //                 leave="transition ease-in duration-100"
    //                 leaveFrom="opacity-100"
    //                 leaveTo="opacity-0"
    //               >
    //                 <Listbox.Options
    //                   static
    //                   className="absolute z-10 max-h-60 w-full py-2 overflow-auto bg-secondary-light shadow-spread focus:outline-none"
    //                 >
    //                   {options.map((option) => (
    //                     <Listbox.Option
    //                       key={option.id}
    //                       className={({ active }) =>
    //                         classNames(
    //                           active && "text-primary",
    //                           "relative cursor-default select-none px-6 py-3"
    //                         )
    //                       }
    //                       value={option.value}
    //                     >
    //                       {({ selected }) => (
    //                         <>
    //                           <span
    //                             className={classNames(
    //                               selected
    //                                 ? "pl-6 font-semibold"
    //                                 : "font-semibold",
    //                               "block truncate font-semibold"
    //                             )}
    //                           >
    //                             {option.key}
    //                           </span>
    //                           {selected ? (
    //                             <span
    //                               className="absolute inset-y-0 left-0 flex items-center pl-2.5"
    //                               aria-hidden="true"
    //                             >
    //                               <CheckIcon className="h-5 w-5" />
    //                             </span>
    //                           ) : null}
    //                         </>
    //                       )}
    //                     </Listbox.Option>
    //                   ))}
    //                 </Listbox.Options>
    //               </Transition>
    //             </div>
    //           )}
    //         </Listbox>
    //         {errors[name] && (
    //           <p className="text-sm text-red-500">{errors[name].message}</p>
    //         )}
    //       </>
    //     )}
    //   />
    // </>
  );
}
